import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { CourseFeedView } from '@/views/feed/course-feed-view.tsx';

// Activity Feed tab（ADR-017）：教师发布的帖子 + 单层评论，
// 带 @mention 自动补全、重要/置顶标志，以及每帖阅读追踪。
export const Route = createFileRoute('/_learner/courses_/$id/feed')({
  component: FeedTab,
});

function FeedTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/feed' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CourseFeedView courseId={id} user={user} />;
}
